<script lang="ts" setup>
import AccordionTab from "~/components/ui/AccordionTab.vue";
const active = ref(false);

interface Props {
	header: any;
	content: any;
  headerClass?: string
  headerInnerClass?: string
  iconClass?: string
}

defineProps<Props>();
</script>

<template>
	<AccordionTab @toggle="active = !active" class="mb-1 rounded-xl bg-light-50 dark:bg-dark-800 dark:text-light-50 text-dark-800" :headerWrapperClass="headerClass" :iconClass="iconClass">
		<template #header>
			<div
				:class="[
					active ? 'rounded-t-lg ' : 'rounded-t-lg  rounded-lg ',
					headerInnerClass ?? 'flex items-center text-sm w-full h-10 p-1 gap-1 font-bold  rounded-t-lg bg-dark-800 dark:bg-dark-700 text-light-50 transition-all whitespace-nowrap flex-shrink-0',
				]"
			>
				{{ header }}
			</div>
		</template>
		<div class="m-2 text-xs font-normal leading-4" v-html="content"></div>
	</AccordionTab>
</template>
